var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { makeStyles } from '@material-ui/core';
import { ArrayUtils, switchUtil } from '@timeflies/common';
import clsx from 'clsx';
import React from 'react';
var tickMaxSize = 6;
var healthPerTick = 25;
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        root: function (_a) {
            var direction = _a.direction;
            return (__assign({ display: 'flex', flexWrap: 'nowrap', flexGrow: 1 }, switchUtil(direction, {
                horizontal: {
                    height: 4
                },
                vertical: {
                    flexDirection: 'column-reverse',
                    height: '100%',
                    width: 4
                }
            })));
        },
        tick: function (_a) {
            var direction = _a.direction;
            return (__assign({ flexGrow: 1, backgroundColor: palette.variables.health }, switchUtil(direction, {
                horizontal: {
                    height: '100%',
                    maxWidth: tickMaxSize,
                    minWidth: 1,
                },
                vertical: {
                    width: '100%',
                    maxHeight: tickMaxSize,
                    minHeight: 1,
                }
            })));
        },
        tickSpace: function (_a) {
            var direction = _a.direction;
            return switchUtil(direction, {
                horizontal: { marginLeft: 2 },
                vertical: { marginBottom: 2 }
            });
        }
    });
});
export var HealthGauge = function (_a) {
    var health = _a.health, direction = _a.direction;
    var classes = useStyles({ direction: direction });
    var nbrTicks = Math.ceil(health / healthPerTick);
    var lastTickSize = health % healthPerTick > 0
        ? Math.max((health % healthPerTick) / healthPerTick * tickMaxSize, 1)
        : undefined;
    return React.createElement("div", { className: classes.root }, ArrayUtils.range(nbrTicks)
        .map(function (i) {
        var _a;
        return (React.createElement("div", { key: i, className: clsx(classes.tick, (_a = {},
                _a[classes.tickSpace] = i !== 0,
                _a)), style: switchUtil(direction, {
                horizontal: {
                    maxWidth: i === nbrTicks - 1 ? lastTickSize : undefined
                },
                vertical: {
                    maxHeight: i === nbrTicks - 1 ? lastTickSize : undefined
                }
            }) }));
    }));
};
